import React from 'react';
import { useEffect, useState } from 'react';
import PlatformPositionCalculator from '../platformPosition.js';

export function DemoScreen({ onStartGame }) {
    const handleDemoClick = () => {
        // Request fullscreen for the iframe or document element
        const element = document.documentElement;
        
        if (element.requestFullscreen) {
            element.requestFullscreen().then(() => {
                onStartGame();
            }).catch((err) => {
                console.log('Fullscreen request failed:', err);
                // Start game anyway even if fullscreen fails
                onStartGame();
            });
        } else if (element.webkitRequestFullscreen) { // Safari
            element.webkitRequestFullscreen();
            onStartGame();
        } else if (element.msRequestFullscreen) { // IE11
            element.msRequestFullscreen();
            onStartGame();
        } else {
            // Fallback: start game without fullscreen
            onStartGame();
        }
    };

    return (
        <div className='demo-screen' onClick={handleDemoClick}>
            <img src='./images/initial_screen.jpg' alt='Initial Screen' />
        </div>
    );
}

export function CloseFullscreenButton({ onExitFullscreen }) {
    const handleClose = () => {
        // Exit fullscreen
        if (document.exitFullscreen) {
            document.exitFullscreen().catch((err) => {
                console.log('Exit fullscreen failed:', err);
            });
        } else if (document.webkitExitFullscreen) { // Safari
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE11
            document.msExitFullscreen();
        }
        
        if (onExitFullscreen) {
            onExitFullscreen();
        }
    };

    return (
        <button className='close-fullscreen-btn' onClick={handleClose}>✕</button>
    );
}

export function InitialScreen() {
    return (
        <div className='initial-screen-container'>
            <div className='initial-screen-text'>
                <img src='./images/gamename.png' alt='Pair & Reveal' />
            </div>
        </div>
    );
}

export function PlayNowButton({ onClick }) {
    // useEffect(() => {
    //     // Initialize the position calculator for play-now-container
    //     const calculator = new PlatformPositionCalculator({
    //         iconContainerSelector: '.play-now-container'
    //     });

    //     // Store for debugging
    //     window.platformCalculator = calculator;

    //     // Cleanup
    //     return () => {
    //         console.log('PlayNowButton position calculator cleaned up');
    //     };
    // }, []);

    return (
        <div className='play-now-container'>
            <button className='play-now-btn' onClick={onClick}>
                Play Now
            </button>
        </div>
    );
}
